export default __webpack_public_path__ + "device_nf.a22275b5.png";